module.exports = __webpack_public_path__ + "static/media/cristalero.bb03f99c.png";